import { SpecificationFieldsManager } from '@/components/specifications/SpecificationFieldsManager';

export default function AdminSpecificationFieldsPage() {
  return (
    <div className="container mx-auto p-6 max-w-7xl">
      <SpecificationFieldsManager />
    </div>
  );
}
